define(function riqToastrStateModule() {
  'use strict';

  var state = function state(mutations) {
    var NAMESPACE = 'riqToastrs';
    var ALIAS = 'riqToastrs';

    return {
      namespace: NAMESPACE,
      alias: ALIAS,
      mutations: mutations
    };
  };

  return state;
});
